import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ApiCall, setFocus } from './utils';
import GoogleCaptcha from './GoogleCaptcha';

export const ModalForm = () => {
    const [enquireLoading, setEnquireLoading] = useState(false)
    const [showModal, setShowModal] = useState(false);
    const [captchaValue, setCaptchaValue] = useState(null);
    const [enquireNowDetails, setEnquireNowDetails] = useState({
        fullName: '',
        companyEmail: '',
        phNumber: '',
        companyName: '',
        websiteDevelopment: false,
        eCommerceSolutions: false,
        webApplicationDevelopment: false,
        mobileApplicationDevelopment: false,
        performanceMarketing: false,
        serachEngineOptimization: false,
        businessConsultancy: false,
        socialMediaOptimization: false,
    })

    const navigate = useNavigate()
    const handleEnquireChange = (e) => {
        const { name, value, type, checked } = e.target;
        setEnquireNowDetails((previous) => ({
            ...previous,
            [name]: type === 'checkbox' ? checked : value
        }))
    }
    const handleEnquireSubmit = async (e) => {

        let req = {
            ...enquireNowDetails,
            CompanyPhoneNo: enquireNowDetails.phNumber
        }
        const { fullName, phNumber, companyName, companyEmail, ...services } = enquireNowDetails;
        if (fullName.trim() === '') {
            toast.error('please enter full name')
            setFocus('txtFullName')
            return
        }
        if (phNumber.trim() === '') {
            toast.error('please enter phone number')
            setFocus('txtPhNumber')
            return
        }
        if (companyEmail.trim() === '') {
            toast.error('please enter company email')
            setFocus('txtCompanyEmail')
            return
        }
        if (companyName.trim() === '') {
            toast.error('please enter company name')
            setFocus('txtCompanyName')
            return
        }

        const isValid = Object.values(services).some(value => value)

        if (isValid) {
            //if (!captchaValue) {
            //    alert('Please complete the reCAPTCHA');
            //    return;
            //}
            try {
                setEnquireLoading(true)
                const res = await ApiCall("/api/Web/enquireNow", req)
                if (res.status === "SUCCESS") {
                    setEnquireLoading(false)
                    toast.success(res.message)
                    handleEnquireReset()
                    setShowModal(false)
                    navigate(`/thankyou?email=${enquireNowDetails.companyEmail}`)
                }
                else if (res.status === "ERROR") {
                    setEnquireLoading(false)
                    toast.error(res.message)
                }
            } catch (error) {
                toast.error('Some error occured, Please try again later!!');
                setEnquireLoading(false)
            } finally {
                setEnquireLoading(false)
            }
        } else {
            toast.error('please select at list one services')
        }
    }

    const handleEnquireReset = () => {
        setEnquireNowDetails((prev) => ({
            fullName: '',
            companyEmail: '',
            phNumber: '',
            companyName: '',
            websiteDevelopment: false,
            eCommerceSolutions: false,
            webApplicationDevelopment: false,
            mobileApplicationDevelopment: false,
            performanceMarketing: false,
            serachEngineOptimization: false,
            businessConsultancy: false,
            socialMediaOptimization: false,
        }))
    }
 
    useEffect(() => {
        setFocus('txtFullName')
    }, [])
    return (
        <>
            <div className="enquiry-now-btn-whatsapp">
                <h3><a className="text-white d-flex gap-2 align-items-center" href="https://api.whatsapp.com/send/?phone=9312765435&text&app_absent=0" target='_blank'>
                    <svg
                        viewBox="0 0 31 30"
                        height={18}
                        preserveAspectRatio="xMidYMid meet"
                        className="x1knego9"
                        fill="none"
                    >
                        <title>{"wa-logo"}</title>
                        <path
                            d="M30.3139 14.3245C30.174 10.4932 28.5594 6.864 25.8073 4.1948C23.0552 1.52559 19.3784 0.0227244 15.5446 4.10118e-06H15.4722C12.8904 -0.00191309 10.3527 0.668375 8.10857 1.94491C5.86449 3.22145 3.99142 5.06026 2.67367 7.28039C1.35592 9.50053 0.6389 12.0255 0.593155 14.6068C0.547411 17.1882 1.17452 19.737 2.41278 22.0024L1.09794 29.8703C1.0958 29.8865 1.09712 29.9029 1.10182 29.9185C1.10651 29.9341 1.11448 29.9485 1.12518 29.9607C1.13588 29.973 1.14907 29.9828 1.16387 29.9896C1.17867 29.9964 1.19475 29.9999 1.21103 30H1.23365L9.01561 28.269C11.0263 29.2344 13.2282 29.7353 15.4586 29.7346C15.6004 29.7346 15.7421 29.7346 15.8838 29.7346C17.8458 29.6786 19.7773 29.2346 21.5667 28.4282C23.3562 27.6218 24.9682 26.469 26.3098 25.0363C27.6514 23.6036 28.696 21.9194 29.3832 20.0809C30.0704 18.2423 30.3867 16.2859 30.3139 14.3245ZM15.8099 27.1487C15.6923 27.1487 15.5747 27.1487 15.4586 27.1487C13.4874 27.1511 11.5444 26.6795 9.79366 25.7735L9.39559 25.5654L4.11815 26.8124L5.09221 21.4732L4.86604 21.0902C3.78579 19.2484 3.20393 17.157 3.17778 15.0219C3.15163 12.8869 3.68208 10.7819 4.71689 8.91419C5.75171 7.0465 7.25518 5.48059 9.07924 4.37067C10.9033 3.26076 12.985 2.64514 15.1194 2.58444C15.238 2.58444 15.3571 2.58444 15.4767 2.58444C18.6992 2.59399 21.7889 3.86908 24.0802 6.13498C26.3715 8.40087 27.681 11.4762 27.7265 14.6984C27.7719 17.9205 26.5498 21.0316 24.3234 23.3612C22.0969 25.6909 19.0444 27.0527 15.8235 27.1532L15.8099 27.1487Z"
                            fill="currentColor"
                        />
                        <path
                            d="M10.2894 7.69007C10.1057 7.69366 9.92456 7.73407 9.75673 7.80892C9.5889 7.88377 9.43779 7.99154 9.31236 8.12584C8.95801 8.48923 7.96736 9.36377 7.91006 11.2003C7.85277 13.0369 9.13594 14.8538 9.31537 15.1086C9.49481 15.3635 11.7686 19.3306 15.5141 20.9395C17.7156 21.8879 18.6806 22.0507 19.3063 22.0507C19.5642 22.0507 19.7587 22.0236 19.9622 22.0115C20.6483 21.9693 22.1969 21.1762 22.5346 20.3137C22.8724 19.4512 22.895 18.6973 22.806 18.5465C22.7171 18.3957 22.4728 18.2872 22.1049 18.0942C21.737 17.9012 19.9321 16.9361 19.5928 16.8004C19.467 16.7419 19.3316 16.7066 19.1932 16.6964C19.1031 16.7011 19.0155 16.7278 18.938 16.774C18.8605 16.8203 18.7954 16.8847 18.7484 16.9618C18.4469 17.3372 17.7548 18.153 17.5225 18.3882C17.4718 18.4466 17.4093 18.4938 17.3392 18.5265C17.2691 18.5592 17.1928 18.5768 17.1154 18.5782C16.9728 18.5719 16.8333 18.5344 16.7068 18.4681C15.6135 18.0038 14.6167 17.339 13.768 16.5079C12.975 15.7263 12.3022 14.8315 11.7716 13.8526C11.5666 13.4726 11.7716 13.2766 11.9586 13.0987C12.1456 12.9208 12.3461 12.675 12.5391 12.4624C12.6975 12.2808 12.8295 12.0777 12.9312 11.8593C12.9838 11.7578 13.0104 11.6449 13.0085 11.5307C13.0067 11.4165 12.9765 11.3045 12.9206 11.2048C12.8317 11.0149 12.1667 9.14664 11.8546 8.39725C11.6013 7.75642 11.2997 7.73531 11.0358 7.7157C10.8187 7.70062 10.5699 7.69309 10.3211 7.68555H10.2894"
                            fill="currentColor"
                        />
                    </svg> 
                    WhatsApp</a></h3>
            </div>
            <div className="enquiry-now-btn">
                <h3><a className="text-white" onClick={() => setShowModal(!showModal)}>Enquire now</a></h3>
            </div>
            <div
                className={`modal fade ${showModal ? 'show d-block scale_anim' : ''}`}
                id="modalId"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalTitleId"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content mybg">
                        <div className="modal-header border-0">
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowModal(false)}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="form-group w-100 position-relative">
                                        <label className="form-label mb-0">FULL NAME <span className='text-danger'>*</span></label>
                                        <input
                                            id='txtFullName'
                                            type="text"
                                            name='fullName'
                                            className='form-control'
                                            value={enquireNowDetails.fullName}
                                            placeholder='Ex. Santosh'
                                            onChange={handleEnquireChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault()
                                                    setFocus("txtCompanyEmail")
                                                };
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group w-100 position-relative">
                                        <label className="form-label mb-0">COMPANY E-MAIL <span className='text-danger'>*</span></label>
                                        <input
                                            id='txtCompanyEmail'
                                            type="text"
                                            className='form-control'
                                            value={enquireNowDetails.companyEmail}
                                            placeholder='example@gmail.com'
                                            name="companyEmail"
                                            onChange={handleEnquireChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault()
                                                    setFocus("txtPhNumber")
                                                };
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group w-100 position-relative">
                                        <label className="form-label mb-0">PHONE NUMBER  <span className='text-danger'>*</span></label>
                                        <input
                                            type="number"
                                            className='form-control'
                                            value={enquireNowDetails.phNumber}
                                            placeholder='0987456123'
                                            name="phNumber"
                                            id='txtPhNumber'
                                            onChange={handleEnquireChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault()
                                                    setFocus("txtCompanyName")
                                                };
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group w-100 position-relative">
                                        <label className="form-label mb-0">COMPANY NAME <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            value={enquireNowDetails.companyName}
                                            placeholder='Example company.Inc'
                                            name="companyName"
                                            id='txtCompanyName'
                                            onChange={handleEnquireChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault()
                                                    setFocus("txtWebsiteDevelopment")
                                                };
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <p>PLEASE SELECT THE SERVICES <span className='text-danger'>*</span></p>
                                    <div className="modal_services">
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='websiteDevelopment'
                                                id="txtWebsiteDevelopment"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.websiteDevelopment === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtECommerceSolutions")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtWebsiteDevelopment">Website Development</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='eCommerceSolutions'
                                                id="txtECommerceSolutions"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.eCommerceSolutions === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtWebApplicationDevelopment")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtECommerceSolutions">E-Commerce Solutions</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='webApplicationDevelopment'
                                                id="txtWebApplicationDevelopment"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.webApplicationDevelopment === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtMobileApplicationDevelopment")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtWebApplicationDevelopment">Web Application Development</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='mobileApplicationDevelopment'
                                                id="txtMobileApplicationDevelopment"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.mobileApplicationDevelopment === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtPerformanceMarketing")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtMobileApplicationDevelopment">Mobile Application Development</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='performanceMarketing'
                                                id="txtPerformanceMarketing"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.performanceMarketing === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtSerachEngineOptimization")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtPerformanceMarketing">Performance Marketing</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='serachEngineOptimization'
                                                id="txtSerachEngineOptimization"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.serachEngineOptimization === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtBusinessConsultancy")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtSerachEngineOptimization">Serach Engine Optimization</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='businessConsultancy'
                                                id="txtBusinessConsultancy"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.businessConsultancy === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtSocialMediaOptimization")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtBusinessConsultancy">Business Consultancy</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='socialMediaOptimization'
                                                id="txtSocialMediaOptimization"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.socialMediaOptimization === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {    
                                                        handleEnquireSubmit(e)
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtSocialMediaOptimization">Social Media Optimization</label>
                                        </div>

                                    </div>

                                    <GoogleCaptcha setCaptchaValue={setCaptchaValue}/>


                                    {
                                        enquireLoading ? <button className="text-decoration-none drona-btn btn w-100 my-4 py-0">Sending... </button> :

                                            <button onClick={(e) => handleEnquireSubmit(e)} className="text-decoration-none drona-btn btn w-100 my-4 py-0">Submit
                                                <svg
                                                    className="ms-2"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={30}
                                                    height={30}
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <style>
                                                        {
                                                            "\n  .send {\n\tanimation: send 2s cubic-bezier(1, -0.47, 0.01, 1.37) infinite both;\n}\n@keyframes send {\n  0% {\n    transform: translateY(0) translateX(0);\n  }\n  100% {\n    transform: translateY(-20px) translateX(20px);\n  }\n}\n\n"
                                                        }
                                                    </style>
                                                    <g className="send">
                                                        <path
                                                            stroke="#fff"
                                                            strokeLinecap="round"
                                                            strokeWidth={1.5}
                                                            d="M9.407 14.593l3.058-3.058"
                                                        />
                                                        <path
                                                            stroke="#fff"
                                                            strokeWidth={1.5}
                                                            d="M15.564 7.908a.432.432 0 01.528.528l-2.677 10.175a.432.432 0 01-.724.195L5.194 11.31a.432.432 0 01.195-.724l10.175-2.677z"
                                                        />
                                                    </g>
                                                </svg>
                                            </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`modal_ovarlay ${showModal ? 'd-block' : 'd-none'}`}></div>
        </>
    )
}
